import { useObrasListaView } from "./use-obras-lista-view";
import { ObrasListaViewView } from "./view-obras-lista-view";
import type { ObrasListaViewProps } from "./types-obras-lista-view";

export function ObrasListaView(props: ObrasListaViewProps) {
  const vm = useObrasListaView(props);

  return <ObrasListaViewView {...vm} />;
}

export type * from "./types-obras-lista-view";
